import { css } from '@emotion/react';
import styled from '@emotion/styled';

//#region Panel
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
const LoadingStateBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
//#endregion

//#region Comment
const CommentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const CommentBox = styled.div<{ isPending?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;

  padding: 12px 16px;

  ${({ isPending: isTemp }) =>
    isTemp &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}
`;
const UserInfo = styled.div<{ isAdmin: boolean; isDeleted?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;

  & > .initial {
    width: 36px;
    height: 36px;

    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ theme: { color, _raw_color }, isAdmin, isDeleted }) => {
      if (isDeleted) {
        return css`
          background-color: ${_raw_color.bluegray100};
          border: 1px solid ${_raw_color.bluegray200};
        `;
      }

      return css`
        background-color: ${isAdmin ? color.bg.surface.inverse.dark : _raw_color.bluegray150};
        border: 1px solid ${isAdmin ? color.bg.surface.inverse.dark : _raw_color.bluegray200};
        & p {
          color: ${isAdmin ? color.content.on_default_color : color.content.neutral.default.normal};
        }
      `;
    }}
  }
  & .email {
    flex: 1;
  }
`;
//#endregion

//#region Reply
const ReplyContainer = styled.div`
  margin-left: 50px;

  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const ReplyPreview = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const ReplyListBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Skeleton = styled.div`
  width: 200px;
  height: 21px;
  background-color: ${({ theme: { color } }) => color.bg.fill.neutral.tint.normal};
  border-radius: 4px;
`;
//#endregion

//#region Thread
const ThreadDividerBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 16px;
  & > p {
    white-space: nowrap;
    flex-shrink: 0;
  }
`;
//#endregion

//#region InputForm
const InputFormContainer = styled.div`
  padding: 8px 16px 16px;
`;
//#endregion

//#region Panel Layout
const PanelContent = styled.div<{ viewMode: 'comment' | 'thread' }>`
  display: flex;
  flex-direction: column;
  ${({ viewMode }) =>
    viewMode === 'comment'
      ? css`
          // 58px - panel header height
          // height: calc(100vh - 58px);
          // height: calc(100dvh - 58px);
          // height: calc(100% - 58px);
          height: 100%;
        `
      : css`
          /* thread 모드는 자연스러운 높이 */
        `}
`;

const ScrollableContent = styled.div<{ viewMode: 'comment' | 'thread' }>`
  ${({ viewMode }) =>
    viewMode === 'comment'
      ? css`
          flex: 1;
          overflow: auto;

          display: flex;
          margin-bottom: 8px;
        `
      : css`
          margin-bottom: 8px;
          /* thread 모드는 자연스러운 높이 */
        `}
`;

const FixedTextEditor = styled.div<{ viewMode: 'comment' | 'thread' }>`
  background: white;
  z-index: 1;

  ${({ viewMode }) =>
    viewMode === 'thread'
      ? css`
          position: sticky;
          bottom: 0;
        `
      : css`
          margin-top: auto;
        `}
`;
//#endregion

export const Styled = {
  HeaderContainer,
  LoadingStateBox,

  CommentContainer,
  CommentBox,
  UserInfo,
  ReplyContainer,
  ReplyPreview,
  ReplyListBox,
  Skeleton,

  ThreadDividerBox,

  InputFormContainer,

  PanelContent,
  ScrollableContent,
  FixedTextEditor,
};
